import { render, staticRenderFns } from "./dealer-form.vue?vue&type=template&id=cb913324"
import script from "./dealer-form.vue?vue&type=script&lang=ts"
export * from "./dealer-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports